export const handleAPIError = (error: any) => {
  return error.message || "An unknown error occurred";
};

export const extractErrorMessage = (error: unknown): string => {
  if (error instanceof Error) {
    return error.message;
  }

  if (typeof error === "string") {
    if (error.startsWith("Failed to fetch")) {
      return "API is unavailable, please check your internet connection and try again later.";
    }
    return error;
  }

  if (error && typeof error === "object" && "message" in error) {
    return String(error.message);
  }

  return "An unknown error occurred";
};
